import BackgroundVideo from '../../../resources/scripts/helpers/background-video';

class BrixHero {
  static init(...parameters) {
    return new BrixHero(...parameters);
  }

  constructor(block) {
    if (block) {
      const backgroundVideoWrapper = document.querySelector(`#${block.id} > .background > .video`);

      if (backgroundVideoWrapper) {
        BackgroundVideo.init(block);
      }
    }
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-hero', BrixHero.init);
}
